export default __webpack_public_path__ + "assets/cdpi-rio-component.0ddf990a.svg";